import { gql } from '@apollo/client'
import { INVOICE_QUERY, FWINVOICE_OUTSIDE_FIRMS_QUERY } from '../graphql'
import { ACTION_TYPE } from '../constants'
import { FIELD_ID } from '../components/CustomCode/FwInvoice/fwinvoice_constants'
import { makeInteger, getLoginItem } from '../utils'
import PlaintiffSelection from '../components/CustomCode/FwInvoice/PlaintiffSelection'

const INVOICE = gql(INVOICE_QUERY)
const FWINVOICE_OUTSIDE_FIRMS = gql(FWINVOICE_OUTSIDE_FIRMS_QUERY)

const fwinvoice = {
  validation_hook: async function validation_hook(fieldInput, objectId, formInputs) {
    const allInputs = window.rootFormInputs
    console.log('fwinvoice.validation_hook', fieldInput, objectId, formInputs, allInputs)

    let validationMessage = ''
    switch (makeInteger(fieldInput.field.id)) {
      case FIELD_ID.invoice.number:
        if (fieldInput.currentValue && makeInteger(formInputs.action.type.id) === ACTION_TYPE.submit) {
          const currentWorkspaceId = getLoginItem('currentWorkspaceId')
          try {
            const results = await window.apolloClient.query({ query: INVOICE, variables: { invoiceNumber: fieldInput.currentValue, workspaceId: currentWorkspaceId } })
            if (results.data.invoice) {
              validationMessage = 'Duplicate invoice number.'
            }
          } catch (err) {
            console.log(JSON.stringify(err))
          }
        }
        break
      case FIELD_ID.invoice.detail:
        if (formInputs[FIELD_ID.invoice.partialInvoice].currentValue === 'N') {
          const invoiceAmount = formInputs[FIELD_ID.invoice.amount].currentValue
          console.log('Invoice Amount: ', invoiceAmount)
          if (invoiceAmount) {
            let sumFees = 0
            let sumCosts = 0

            for (let gridRow of fieldInput.currentValue.gridData) {
              const detail = fieldInput.currentValue[gridRow[0]]
              let fees = 0
              let costs = 0
              if (detail) {
                fees = detail[FIELD_ID.invoiceDetail.fees].currentValue
                costs = detail[FIELD_ID.invoiceDetail.costs].currentValue
              } else {
                fees = gridRow[2] ? parseFloat(gridRow[2].trim().replace('$', '').replace(/,/g, '')) : 0
                costs = gridRow[3] ? parseFloat(gridRow[3].trim().replace('$', '').replace(/,/g, '')) : 0
              }
              sumFees += fees ? fees * 100 : 0
              sumCosts += costs ? costs * 100 : 0
              console.log(`fees: ${typeof fees} ${fees} sumFees: ${sumFees} costs: ${typeof costs} ${costs} sumCosts: ${sumCosts}`)
            }

            // for (let detailId in details.currentValue) {
            //   if (parseInt(detailId)) {
            //     const detail = details.currentValue[detailId]
            //     const fees = detail[FIELD_ID.invoiceDetail.fees].currentValue
            //     const costs = detail[FIELD_ID.invoiceDetail.costs].currentValue
            //     sumFees += fees ? fees * 100 : 0
            //     sumCosts += costs ? costs * 100 : 0
            //     console.log(`fees: ${fees} sumFees: ${sumFees} costs: ${costs} sumCosts: ${sumCosts}`)
            //   }
            // }

            console.log(`sumFees + sumCosts: ${typeof (sumFees + sumCosts) / 100} ${(sumFees + sumCosts) / 100} invoiceAmount: ${typeof invoiceAmount} ${invoiceAmount}`)
            if ((sumFees + sumCosts) / 100 !== invoiceAmount) {
              const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
              console.log(`sumFees: ${sumFees} sumCosts: ${sumCosts}`)
              validationMessage = `The sum of Fees and Costs (${formatter.format((sumFees + sumCosts)/100)}) must equal Invoice Amount (${formatter.format(invoiceAmount)}).`
            }
          }
        }
        break
      case FIELD_ID.invoiceDetail.fees:
        const fees = formInputs[FIELD_ID.invoiceDetail.fees].currentValue
        const costs = formInputs[FIELD_ID.invoiceDetail.costs].currentValue
        if (!fees && !costs) {
          validationMessage = 'Either Fees or Costs, or both, must contain a valid dollar amount.'
        }
        break
      default:
        console.log(`fwinvoice.validation_hook "${fieldInput.field.validationHook}" not handled for field "${fieldInput.field.name}".`)
        validationMessage = ''
    }
    console.log('validationMessage: ', validationMessage)
    return validationMessage
  },

  choice_hook: async function choice_hook(field, object, parentObjectId, allInputs) {
    console.log('fwinvoice.choice_hook', field, object, parentObjectId, allInputs)
    let choices = []
    switch (makeInteger(field.id)) {
      case FIELD_ID.invoice.outsideFirm:
        const results = await window.apolloClient.query({ query: FWINVOICE_OUTSIDE_FIRMS })
        console.log('fwinvoice.choice_hook', results)
        choices = results.data.outsideFirms
        break
      default:
        console.log(`fwinvoice.choice_hook field "${field.name}" not handled.`)
    }
    return choices
  },

  plaintiff_selection: function plaintiff_selection(objectId, field, selectFieldCallback, setLargeChoice) {
    console.log('fwinvoice.plaintiff_selection')
    return (
      <PlaintiffSelection callback={selectFieldCallback} setSelectLargeChoice={setLargeChoice}/>
    )
  }
}

export default fwinvoice